import { Flex } from '@chakra-ui/react'
import { FaTrashAlt } from 'react-icons/fa'
import { FiEdit, FiEye } from 'react-icons/fi'
import { HiUserGroup } from 'react-icons/hi2'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { ISquad } from '../../../../../../interfaces'
import { parseJwt } from '../../../../../../services/token'
import { Container } from './styles'

interface ISquadGestaoCardProps {
  squad: ISquad
  onEdit: () => void
  onDelete: () => void
  onVerPessoas: () => void
}

export const SquadGestaoCard: React.FC<ISquadGestaoCardProps> = ({ squad, onEdit, onDelete, onVerPessoas }) => {
  const ehAdm = parseJwt().adm === 'True'
  const qtdColaboradores = squad.colaboradores?.length ?? 0
  return (
    <Container>
      <Flex justifyContent={'space-between'} mt={'.25rem'}>
        <strong>{squad.nome}</strong>
        <Flex alignItems={'center'} gap={'.5rem'} w={'10rem'} justifyContent={'end'}>
          <ButtonCmp small OutlineColor='Azul' title='Ver colaboradores' onClick={onVerPessoas}>
            <FiEye />
          </ButtonCmp>
          {ehAdm &&
            <ButtonCmp small OutlineColor='Rosa' onClick={onEdit}>
              <FiEdit />
            </ButtonCmp>
          }
          {ehAdm && qtdColaboradores === 0 &&
            <ButtonCmp small OutlineColor='Red' onClick={onDelete}>
              <FaTrashAlt />
            </ButtonCmp>
          }
        </Flex>
      </Flex>
      <Flex gap={'.325rem'} bg={'var(--Azul)'} color={'var(--c1)'} pos={'absolute'} top={'0'} left={'50%'} transform={'translate(-50%, -0%)'} p={'.325rem 1.5rem'} alignItems={'center'} borderRadius={'0 0 .5rem .5rem'}>
        <HiUserGroup size={14}/>
        <strong style={{ fontSize: '.813rem', fontWeight: 900 }}>{qtdColaboradores}</strong>
      </Flex>
    </Container>
  )
}
